import React, { useEffect, useState } from "react";
import { skills } from "../config/config";

const Skills = () => {
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const skillContainers = document.querySelectorAll(".skill-container");
      skillContainers.forEach((container, index) => {
        const rect = container.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          setVisible((prevVisible) => [...new Set([...prevVisible, index])]);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on load
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="skills" className="text-white p-8 flex flex-col items-center">
      <h2 className="text-3xl sm:text-4xl font-extrabold mb-12 text-center text-gray-100">Skills</h2>
      <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
        {skills.map((skill, index) => (
          <div
            key={index}
            className={`skill-container transform transition-all duration-700 ease-out ${
              visible.includes(index)
                ? "opacity-100 translate-y-0 scale-100"
                : "opacity-0 translate-y-8 scale-95"
            }`}
            style={{
              transitionDelay: `${index * 0.05}s`,
            }}
          >
            <div className="flex items-center space-x-3 px-6 py-3 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 transition-colors duration-300 hover:border-sky-400/50 hover:shadow-[0_0_15px_rgba(56,189,248,0.2)] group cursor-default">
              <div className="text-2xl text-gray-300 group-hover:text-sky-400 transition-colors">
                {skill.icon}
              </div>
              <span className="text-sm sm:text-base font-semibold text-gray-200 group-hover:text-white transition-colors">
                {skill.name}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
